module.exports = __webpack_public_path__ + "img/PUEDE.9413dc09.png";